import tw from "twin.macro"

export const Section = tw.section`mb-10`
